import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminSidebar.css';

export default function AdminSidebar({ counts = {} }) {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const close = () => setOpen(false);

  const NAV = [
    {
      to: '/admin/dashboard', label: 'Dashboard',
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
    },
    {
      to: '/admin/quotes', label: 'Quotes', count: counts.quotes,
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
    },
    {
      to: '/admin/projects', label: 'Projects', count: counts.projects,
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
    },
    {
      to: '/admin/products', label: 'Products', count: counts.products,
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
    },
    {
      to: '/admin/testimonials', label: 'Testimonials', count: counts.testimonials,
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    },
    {
      to: '/admin/settings', label: 'Settings',
      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
    },
  ];

  const SidebarContent = () => (
    <div className='asb-inner'>
      <div className='asb-brand'>
        <span className='asb-dot'></span>
        <span className='asb-brand-name'>RastegHub</span>
        <span className='asb-admin-label'>Admin</span>
      </div>
      <nav className='asb-nav'>
        <p className='asb-section-label'>Navigation</p>
        {NAV.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={close}
            className={({ isActive }) => `asb-nav-item ${isActive ? 'asb-nav-item--active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
            {item.count > 0 && <span className='asb-count'>{item.count}</span>}
          </NavLink>
        ))}
      </nav>
      <div className='asb-footer'>
        <div className='asb-user'>
          <div className='asb-user-avatar'>{admin?.username?.[0]?.toUpperCase() || 'A'}</div>
          <div className='asb-user-info'>
            <span className='asb-user-name'>{admin?.username || 'Admin'}</span>
            <span className='asb-user-role'>Administrator</span>
          </div>
        </div>
        <button className='asb-logout' onClick={handleLogout} title='Sign out'>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </div>
  );

  return (
    <>
      <aside className='asb-sidebar'><SidebarContent /></aside>
      <div className='asb-mobile-bar'>
        <div className='asb-brand'>
          <span className='asb-dot'></span>
          <span className='asb-brand-name'>RastegHub</span>
          <span className='asb-admin-label'>Admin</span>
        </div>
        <button className={`asb-hamburger ${open ? 'asb-hamburger--open' : ''}`} onClick={() => setOpen(o => !o)} aria-label='Toggle menu'>
          <span></span><span></span><span></span>
        </button>
      </div>
      {open && (
        <div className='asb-overlay' onClick={close}>
          <aside className='asb-drawer' onClick={e => e.stopPropagation()}>
            <SidebarContent />
          </aside>
        </div>
      )}
    </>
  );
}